import '@agrial/ui/dist/index.css'
import Vue from 'vue'

import PropertiesLoader from '@agrial/front-properties'

import VueCookies from 'vue-cookies'
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import app from './App'
import createRouter from './router'
import axios from 'axios'
import store from './store'
import setAppTitle from '@/utils/dynamically-title-app'
import SecurityPlugin from '@agrial/vue-plugin-security'
import HttpConfig from './plugins/http-config'
import filterNumber from '@/filters/number.filter'
import filterDate from '@/filters/date.filter'
import filterString from '@/filters/string.filter'
import BaseComponents from '@/plugins/base-components'
import DidomiGtag from '@/plugins/didomi-gtag'
import '@/plugins/didomi'
import vuetify from '@/plugins/vuetify'
import '@agrial/vue-plugin-security/dist/index.css'
import '@/styles/colors.css'
import '@/styles/vendor-vuetify.scss'
import '@/styles/main.scss'
import '@/styles/fonts.scss'
import '@/styles/_font-size-overrides.scss'
import '@/styles/tooltip.scss'
import VueApexCharts from 'vue-apexcharts'
import VueGtag from 'vue-gtag'
import VTooltip from 'v-tooltip'
import VueQuill from 'vue-quill'
import Vuelidate from 'vuelidate'
import 'quill/dist/quill.snow.css'
import rolesUtils from '@/utils/roles'

PropertiesLoader.loadProperties(
  ['/application.properties', '/configuration/application.properties']
).then((properties) => {
  window.PROPERTIES = properties
  Vue.config.productionTip = false
  Chart.register(ChartDataLabels)
  const router = createRouter()
  Vue.use(VueGtag, {
    enabled: window.PROPERTIES.has('GOOGLE_ANALYTICS_ID'),
    config: {
      id: window.PROPERTIES.get('GOOGLE_ANALYTICS_ID')
    },
    pageTrackerTemplate (to) {
      const title = to.matched.reduce((t, i) => i.meta?.title || t, null) || to.name
      return {
        page_title: title,
        page_path: to.path
      }
    }
  }, router)
  Vue.prototype.$roles = rolesUtils
  Vue.use(BaseComponents)
  Vue.use(setAppTitle, router)
  Vue.use(VueApexCharts)
  Vue.component('apexchart', VueApexCharts)
  Vue.use(VueQuill)
  Vue.use(Vuelidate)
  Vue.use(HttpConfig)

  Vue.use(SecurityPlugin, {
    router,
    store,
    axios
  })
  Vue.use(VueCookies)
  Vue.use(VTooltip)
  Vue.use(DidomiGtag)

  Vue.filter('roundNumber', filterNumber.formatNumber)
  Vue.filter('splitNumber', filterNumber.split)
  Vue.filter('date', filterDate.formatDate)
  Vue.filter('parse', filterDate.parseDate)
  Vue.filter('capitalize', filterString.capitalize)
  Vue.filter('preposition', filterString.prepositionApostrophe)
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(app)
  }).$mount('#app')
})
